import { Brand, DeckPrint, DeckViewer } from "../headliner/DeckShell";
import { CinematicCover, CINE_ASSETS } from "../headliner/CinematicCover";
import { Wordmark } from "../headliner/brands";
import { TEAM } from "../headliner/TeamAndPartners";
import { variantOf } from "./recipients";
import { Byen, Rommet, HvemStarBak, Kevin, Okonomien, Gatene, Lasen, Ringvirkninger, HvaViBerOm, HvaDuFar, NittiDager, LEVERES_ASSETS } from "./InvestorSlides";
import "../headliner/headliner.css";
import "../lawpartner/law.css";
import "../buildpartner/build.css";
import "../visiondeck/vision-deck.css";
import "../masterdeck/master.css";
import "./investor.css";

/* Investordeck (norsk) — Bergen-basert kapital, det offentlige laget og nasjonal kapital. Ikke en oversettelse av Vision-decket: en annen historie.
   Byen/Arenaen → rommet → hvem står bak → Kevin → økonomien uten pynt → gatene → [låsen | ringvirkninger] → hva vi ber om → hva du får → 90 dager.
   Variant i kategorifeltet: «privat» (default, grunnleggerkretsen i Bergen) · «nasjonal» (samme instrument, byen er scenen, ikke argumentet) · «offentlig» (vertskapsby / regional partner).
   Alle tall: arbeidsbudsjett v1.1 (Unite-indikert produksjon), eks. mva., ikke revidert — merket «indikativt». Ingen ROI-hype: oppsiden er 2028+. */
const KEVIN_CAP_NO = ["Foreslått åpningstaler", "Kevin O'Leary", "Tilgjengelig 13. april · ikke kontrahert"];

const Cover = ({ mottaker, category }) => {
  const off = variantOf(category) === "offentlig";
  return (
    <CinematicCover
      className="ms-cover iv-cover"
      testid="iv-cover"
      kevinCap={KEVIN_CAP_NO}
      lockup={mottaker
        ? <p className="bd-lockup" data-testid="iv-lockup"><Brand size={19} /><i>×</i><Wordmark name={mottaker} h={26} /></p>
        : <p className="bd-lockup" data-testid="iv-lockup"><Brand size={19} /></p>}
      label={<><b>{off ? "Vertskapsbyen" : "Grunnleggerkretsen"}</b>{mottaker ? `Utarbeidet for ${mottaker} · ` : ""}Fortrolig</>}
      title={["Norwegian", "AI Summit"]}
      sub={<><span className="l1">700 ledere. Én dag. Grieghallen, Bergen.</span>En nasjonal konferanse om kunstig intelligens. Tema 2027: <b style={{ whiteSpace: "nowrap" }}>The Next Shift</b>.</>}
      index={[
        ["Dato · Sted", "13. april 2027 · Grieghallen, Bergen"],
        off ? ["Invitasjonen", "Vertskapsby · regional partner", "", "iv-cover-position"] : ["Invitasjonen", "Grunnleggerkretsen · konvertibelt lån", "", "iv-cover-position"],
        ["Leveres med", "Unite Event · Cure · Grieghallen · Replit", "ms-cover-coal", "iv-cover-coalition"],
      ]}
    />
  );
};

/* 11 slides i begge varianter — slide 08 byttes: privat «Garantien» · offentlig «Ringvirkninger» */
const slidesFor = (mottaker, category) => [
  Cover, Byen, Rommet, HvemStarBak, Kevin, Okonomien, Gatene,
  variantOf(category) === "offentlig" ? Ringvirkninger : Lasen,
  HvaViBerOm, HvaDuFar, NittiDager,
];

const ASSETS = [...CINE_ASSETS, "/images/headliner/kevin-src-hi.webp", "/images/bergen-night.webp", "/images/what-room-v4.webp", ...TEAM.map((t) => t[2]), ...LEVERES_ASSETS];

export function InvestorPrint() {
  return <DeckPrint slides={slidesFor} fallback="" />;
}

export default function InvestorDeck({ mottaker = "", publicMode = false }) {
  return <DeckViewer deck="investor" slides={slidesFor} fallback={mottaker} filePrefix="Norwegian-AI-Summit-Grunnleggerkretsen" assets={ASSETS} publicMode={publicMode} categoryField="variant" no />;
}
